export var MAKE_A_PAYMENT = 0;
export var APPLY_TAX_CERTIFICATE = 1;
export var CONVERT_TO_CREDIT = 2;
export var VIEW_RECEIVABLES = 3;